import styles from './styles';
import { useContext } from 'react';
import { ThemeContext } from '../../App';
import { generalButtonStyle } from '../../utils/styles/mainStyles';

export const PopUpComponent = (props) => {
    const [theme,setTheme] = useContext(ThemeContext);

    return (
        <>
{        props.open ? <div 
        style = {styles.popUpOverlay(theme)}
        >
            <div style = {styles.popUpBody(theme)}>
                <div style = {styles.popUpContent(theme)}>
                    {props.content}
                </div>
            <div style = {styles.popUpFooter(theme)}>
                {props.footer ?? 
                <div style = {{width: '100%', textAlign: 'center'}}>
                    <button style = {{...generalButtonStyle(theme),margin: 0}} onClick = {() => {props.setOpen(!props.open)}}>Close</button>
                </div>
                }
            </div>
            </div>
        </div> : null
}
        </>
    )
}